const Setting = {
  /**
   * 是否含有cas登录 false->否   true->是
   */
  isCas: true,
  /**
   * cas跳转的地址
   */
  casUrl: 'https://casauth.lywly.com.cn'
}

export default Setting
